export default {
  "front": {
    "company_lbl": "Sponly",
    "url": "https://app.sponly.ai",
    "email": "support@sponly.ai",
    "phone": "+1888555555",
    "addr_lbl": "Example st. 57, Region, Country, 4138910"
  },
  "back": {
    "app": {
      "url": "https://api.sponly.ai"
    }
  },
  "sentry": {
    "front": {
      "dsn": "https://f6fbae673795c12fe54b306597d88cf5@o4512242264965120.ingest.us.sentry.io/4512242269683712"
    },
    "back": {
      "dsn": "https://0810980a988a3e7a7ae8383bb98da8f1@o4512242264965120.ingest.us.sentry.io/4512242289999872"
    }
  },
  "auth0": {
    "domain": "sponly.us.auth0.com",
    "client_id": "80PkCHw3ajvsniuVlUzc8K5EKHjK7NuU",
    "audience": "https://sponly.us.auth0.com/api/v2/"
  },
  "facebook": {
    "app_id": "1935941013773179"
  },
  "sbase": {},
  "google": {
    "analytic_id": "G-XXXXXXXXXX"
  },
  "clarity": {
    "id": "ywghhyndkh"
  },
  "domain": "sponly.ai",
  "is_prod": true,
  "ver": "1.0.8",
  "is_local": false,
  "stage": "prod",
  "bucket_ext": "sponly-front-share-prod"
}